
      var _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgCircleArrowIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 48,
  height: 48,
  viewBox: "0 0 48 48"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
  id: "CircleArrowIcon_d6c9fd937d916a24__a",
  x: 0,
  y: 0,
  width: 48,
  height: 48,
  filterUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("feOffset", {
  dy: 3
}), /*#__PURE__*/React.createElement("feGaussianBlur", {
  stdDeviation: 3,
  result: "blur"
}), /*#__PURE__*/React.createElement("feFlood", {
  floodOpacity: 0.161
}), /*#__PURE__*/React.createElement("feComposite", {
  operator: "in",
  in2: "blur"
}), /*#__PURE__*/React.createElement("feComposite", {
  in: "SourceGraphic"
})))), /*#__PURE__*/React.createElement("g", {
  "data-name": "Group 7820"
}, /*#__PURE__*/React.createElement("g", {
  style: {
    filter: "url(#CircleArrowIcon_d6c9fd937d916a24__a)"
  }
}, /*#__PURE__*/React.createElement("circle", {
  "data-name": "Ellipse 91",
  cx: 15,
  cy: 15,
  r: 15,
  transform: "translate(8.999 6)",
  style: {
    fill: "var(--theme-primary, #810ea9)"
  }
})), /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 1804",
  d: "m0 0 3.706 3.743L0 7.406",
  transform: "rotate(180 12.926 12.352)",
  style: {
    fill: "none",
    stroke: "#fff",
    strokeWidth: "1.5px"
  }
})));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"48\" height=\"48\" viewBox=\"0 0 48 48\">\r\n    <defs>\r\n        <filter id=\"a\" x=\"0\" y=\"0\" width=\"48\" height=\"48\" filterUnits=\"userSpaceOnUse\">\r\n            <feOffset dy=\"3\"/>\r\n            <feGaussianBlur stdDeviation=\"3\" result=\"blur\"/>\r\n            <feFlood flood-opacity=\".161\"/>\r\n            <feComposite operator=\"in\" in2=\"blur\"/>\r\n            <feComposite in=\"SourceGraphic\"/>\r\n        </filter>\r\n    </defs>\r\n    <g data-name=\"Group 7820\">\r\n        <g style=\"filter:url(#a)\">\r\n            <circle data-name=\"Ellipse 91\" cx=\"15\" cy=\"15\" r=\"15\" transform=\"translate(8.999 6)\" style=\"fill:var(--theme-primary, #810ea9)\"/>\r\n        </g>\r\n        <path data-name=\"Path 1804\" d=\"m0 0 3.706 3.743L0 7.406\" transform=\"rotate(180 12.926 12.352)\" style=\"fill:none;stroke:#fff;stroke-width:1.5px\"/>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/CircleArrowIcon.d6c9fd937d916a24cda7f640bb795f82.svg"),
        {
          React: SvgCircleArrowIcon,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      